import React, { useEffect } from 'react';
import { PortalProvider } from 'react-portal-hook';
import { MutableSnapshot, RecoilRoot } from 'recoil';
import { Offer } from '~/common/models';
import { ActiveSpecialOffer } from './store';
import { OffersLocation } from '../special-offers/components/offer-header';
import { OfferBanner } from './components/offer-banner';
import styles from './index.module.scss';
import { OfferLandingContent } from './components/offer-content';

interface SpecialOffersProps {
  offer: Offer;
}

export const SpecialOffer = (props: SpecialOffersProps) => {
  const initialize = ({ set }: MutableSnapshot) => {
    set(ActiveSpecialOffer, props.offer);
  };
  useEffect(() => {
    window['pushDigitalData']({
      event: '_pageLoaded',
    });
  }, []);
  return (
    <RecoilRoot initializeState={initialize}>
      <PortalProvider>
        <div className={styles.offerLocation}>
          <OffersLocation />
        </div>
        <OfferBanner />
        <OfferLandingContent />
      </PortalProvider>
    </RecoilRoot>
  );
};
